import { siteInfo } from "@/mocks/site";

const positions = [
  {
    icon: "ri-focus-3-line",
    title: "只做整理，不做放大",
    desc: "把公开信息按时间线理清楚，不靠夸张标题制造对立。",
  },
  {
    icon: "ri-shield-check-line",
    title: "有出处才写",
    desc: "无法核实的说法只做提示，不写成确定结论。",
  },
  {
    icon: "ri-time-line",
    title: "每天固定更新",
    desc: "合集每天上午上线，榜单固定结算，节奏稳定可预期。",
  },
];

export default function IntroSection() {
  return (
    <section className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
      <div className="order-2 lg:order-1">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-quill-pen-line text-[11px]"></i>
          </span>
          品牌介绍
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {siteInfo.name}，一个把娱乐话题讲清楚的资讯站
        </h2>
        <div className="mt-5 flex flex-col gap-4 text-sm leading-[1.9] text-foreground-700">
          <p>
            {siteInfo.name}从 {siteInfo.since} 年开始整理每日娱乐话题。最初的形态只是一份发在群里的
            文档，把当天刷到的消息按时间顺序排好，标上出处。后来整理得越来越细，就慢慢长成了现在的网站。
          </p>
          <p>
            我们把网站定位成「娱乐话题的整理者」，而不是「爆点的制造者」。同一件事，我们更关心它前后发生
            了什么、当事人有没有回应、公开信息之间是否互相矛盾，而不是它够不够劲爆。
          </p>
          <p>
            对读者来说，最直接的感受应该是：看完一篇，就知道今天这些话题到底是怎么回事，不用再去几个平台
            来回对照。
          </p>
        </div>
      </div>

      <div className="order-1 lg:order-2">
        <div className="h-64 w-full overflow-hidden rounded-card bg-background-200 md:h-80">
          <img
            src="https://readdy.ai/api/search-image?query=bold%20stylized%20editorial%20collage%20illustration%20of%20layered%20paper%20cards%20and%20abstract%20timeline%20lines%20in%20warm%20coral%20amber%20gold%20and%20deep%20teal%20on%20cream%20background%2C%20halftone%20dots%20and%20grain%20texture%2C%20elegant%20modern%20magazine%20art%20direction%2C%20no%20text%2C%20no%20people%2C%20soft%20diffused%20studio%20lighting&width=1200&height=900&seq=gw-about-intro-2026&orientation=landscape"
            alt="瓜田日报内容整理流程配图"
            title="关于瓜田日报"
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {positions.map((item) => (
            <div
              key={item.title}
              className="rounded-card border border-background-200/80 bg-background-50 p-4"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-base`}></i>
              </span>
              <h3 className="mt-3 text-sm font-bold text-foreground-900">{item.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}